import { render, staticRenderFns } from "./BrandArea.vue?vue&type=template&id=42e809ee&scoped=true&"
import script from "./BrandArea.vue?vue&type=script&lang=js&"
export * from "./BrandArea.vue?vue&type=script&lang=js&"
import style0 from "./BrandArea.vue?vue&type=style&index=0&id=42e809ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e809ee",
  null
  
)

export default component.exports